import { useMemo } from "react";
import { useAuth } from "src/hooks/use-auth";
import { SvgIcon } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import { Chip, SvgIcon } from "@mui/material";
// import AlignLeft02Icon from "src/icons/untitled-ui/duocolor/align-left-02";
// import BarChartSquare02Icon from "src/icons/untitled-ui/duocolor/bar-chart-square-02";
// import Building04Icon from "src/icons/untitled-ui/duocolor/building-04";
// import CalendarIcon from "src/icons/untitled-ui/duocolor/calendar";
// import CheckDone01Icon from "src/icons/untitled-ui/duocolor/check-done-01";
// import CreditCard01Icon from "src/icons/untitled-ui/duocolor/credit-card-01";
// import CurrencyBitcoinCircleIcon from "src/icons/untitled-ui/duocolor/currency-bitcoin-circle";
import File01Icon from "src/icons/untitled-ui/duocolor/file-01";
// import GraduationHat01Icon from "src/icons/untitled-ui/duocolor/graduation-hat-01";
// import HomeSmileIcon from "src/icons/untitled-ui/duocolor/home-smile";
// import LayoutAlt02Icon from "src/icons/untitled-ui/duocolor/layout-alt-02";
// import LineChartUp04Icon from "src/icons/untitled-ui/duocolor/line-chart-up-04";
// import Lock01Icon from "src/icons/untitled-ui/duocolor/lock-01";
// import LogOut01Icon from "src/icons/untitled-ui/duocolor/log-out-01";
// import Mail03Icon from "src/icons/untitled-ui/duocolor/mail-03";
// import Mail04Icon from "src/icons/untitled-ui/duocolor/mail-04";
// import MessageChatSquareIcon from "src/icons/untitled-ui/duocolor/message-chat-square";
// import ReceiptCheckIcon from "src/icons/untitled-ui/duocolor/receipt-check";
// import Share07Icon from "src/icons/untitled-ui/duocolor/share-07";
// import ShoppingBag03Icon from "src/icons/untitled-ui/duocolor/shopping-bag-03";
// import ShoppingCart01Icon from "src/icons/untitled-ui/duocolor/shopping-cart-01";
// import Truck01Icon from "src/icons/untitled-ui/duocolor/truck-01";
// import Upload04Icon from "src/icons/untitled-ui/duocolor/upload-04";
// import Users03Icon from "src/icons/untitled-ui/duocolor/users-03";
// import XSquareIcon from "src/icons/untitled-ui/duocolor/x-square";
// import { tokens } from "src/locales/tokens";
import { paths } from "src/paths";
import { GiSouthKorea } from "react-icons/gi";
import { PiBuildingApartmentLight } from "react-icons/pi";
import { CustomIcon } from "src/components/custom-icon";
// import { PiBuildingApartmentFill } from "react-icons/pi";
import { TbDeviceAnalytics } from "react-icons/tb";
import { MdOutlineAnalytics, MdOutlineNoteAlt } from "react-icons/md";
import { MdOutlineForum, MdOutlineMenuBook, MdOutlineStorage } from "react-icons/md";
// import { PiCityLight } from "react-icons/pi";
import { MdOutlineAdminPanelSettings } from "react-icons/md";
import { GrTest } from "react-icons/gr";
import { TbChartInfographic } from "react-icons/tb";
import { dashboardEntry } from "./dashboard-entry";
import {
  getOpportunitySubmenus,
  DASHBOARD_TAB_DEFAULT_PATHS,
  DASHBOARD_TAB_SUBMENUS,
} from "./dashboard-tab-submenus";

export const useSections = () => {
  const { user } = useAuth();
  const isAdmin = Boolean(user?.isAdmin);
  // const { t } = useTranslation();

  return useMemo(() => {
    return [
      // 대시보드
      {
        items: [
          {
            ...dashboardEntry,
            icon: (
              <CustomIcon>
                <TbChartInfographic style={{ width: "100%", height: "100%" }} />
              </CustomIcon>
            ),
          },
        ],
      },
      // Step 1. Nationwide overview
      {
        subheader: "전국현황",
        items: [
          {
            title: "전국현황",
            path: paths.dashboard.condition.mainRegionIndex,
            icon: (
              <CustomIcon>
                <GiSouthKorea style={{ width: "100%", height: "100%" }} />
              </CustomIcon>
            ),
            items: [
              {
                title: "시장 현황(주간증감)",
                // 상위 메뉴 클릭도 첫 번째 지수 탭을 명시해 저장된 이전 탭을 초기화한다.
                path: DASHBOARD_TAB_DEFAULT_PATHS.weekly,
                items: DASHBOARD_TAB_SUBMENUS.weekly,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "시장 현황(월간현황)",
                path: paths.dashboard.condition.mainRegionMonthly,
                items: DASHBOARD_TAB_SUBMENUS.monthly,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "시장 기회 현황",
                path: paths.dashboard.condition.marketOpportunityStatus,
                items: getOpportunitySubmenus(isAdmin),
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "시도 현황",
                path: paths.dashboard.condition.sidoMainIndex,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "군구 현황",
                path: paths.dashboard.condition.gunguMainIndex,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "사이클 분석",
                path: paths.dashboard.condition.cycle,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              // {
              //   title: "리스크 모니터",
              //   path: paths.dashboard.rregion.risk,
              //   icon: (
              //     <SvgIcon fontSize="small">
              //       <File01Icon />
              //     </SvgIcon>
              //   ),
              // },
            ],
          },
        ],
      },
      // Step 2. 지역
      {
        subheader: "지역",
        items: [
          {
            title: "지역",
            path: paths.dashboard.regions.info2,
            icon: (
              <CustomIcon>
                <TbDeviceAnalytics sx={{ width: "100%", height: "100%" }} />
              </CustomIcon>
            ),
            items: [
              // 상승 진단 — 알고리즘 신뢰성 검증 전까지 메뉴에서 임시 숨김.
              // 라우트는 유지하여 직접 URL로는 접근 가능.
              // {
              //   title: "상승 진단",
              //   path: paths.dashboard.rregion.screening,
              //   icon: (
              //     <SvgIcon fontSize="small">
              //       <File01Icon />
              //     </SvgIcon>
              //   ),
              // },
              {
                title: "지역 분석",
                path: paths.dashboard.regions.info2,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "지도 분석",
                path: paths.dashboard.mregion.analyze,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "관심 지역",
                path: paths.dashboard.regions.favorite,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
            ],
          },
        ],
      },
      // Step 3. 아파트
      {
        subheader: "아파트",
        items: [
          {
            title: "아파트",
            path: paths.dashboard.apts.select,
            icon: (
              <CustomIcon>
                <PiBuildingApartmentLight
                  sx={{ width: "100%", height: "100%" }}
                />
              </CustomIcon>
            ),
            items: [
              {
                title: "아파트 검색",
                path: paths.dashboard.apts.select,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "지도 검색",
                path: paths.dashboard.apts.selectmap,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "저평가 판단",
                path: paths.dashboard.apts.undervalue,
                items: DASHBOARD_TAB_SUBMENUS.undervalue,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              // Temporarily hide the upside menu while the model and collected data are validated.
              // Keep the path, route, and screen implementation for later reactivation.
              // {
              //   title: "상승여력",
              //   path: paths.dashboard.apts.upside,
              //   icon: (
              //     <SvgIcon fontSize="small">
              //       <File01Icon />
              //     </SvgIcon>
              //   ),
              // },
              ...(isAdmin ? [{
                title: "급매 판단",
                path: paths.dashboard.apts.bargain,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              }] : []),
              {
                title: "신고가/급락",
                path: paths.dashboard.apts.newHighDrop,
                items: DASHBOARD_TAB_SUBMENUS.newHighDrop,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "관심 아파트",
                path: paths.dashboard.apts.group,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
            ],
          },
        ],
      },
      // Step 4. 분석
      {
        subheader: "분석",
        items: [
          {
            title: "분석",
            path: paths.dashboard.analyze.multi,
            icon: (
              <CustomIcon>
                <MdOutlineAnalytics sx={{ width: "100%", height: "100%" }} />
              </CustomIcon>
            ),
            items: [
              {
                title: "분석만들기",
                path: paths.dashboard.analyze.multi,
                icon: (
                  <CustomIcon>
                    <MdOutlineAnalytics sx={{ width: "100%", height: "100%" }} />
                  </CustomIcon>
                ),
              },
              {
                title: "분석노트",
                path: paths.dashboard.analyze.notes,
                icon: (
                  <CustomIcon>
                    <MdOutlineNoteAlt style={{ width: "100%", height: "100%" }} />
                  </CustomIcon>
                ),
              },
            ],
          },
        ],
      },
      {
        subheader: "커뮤니티",
        items: [
          {
            title: "의견나누기",
            path: paths.dashboard.community.index,
            icon: (
              <CustomIcon>
                <MdOutlineForum style={{ width: "100%", height: "100%" }} />
              </CustomIcon>
            ),
          },
        ],
      },
      {
        subheader: "이용안내",
        items: [
          {
            title: "이용안내",
            icon: (
              <CustomIcon>
                <MdOutlineMenuBook style={{ width: "100%", height: "100%" }} />
              </CustomIcon>
            ),
            items: [
              {
                title: "PropLake 사용법",
                path: paths.dashboard.guide.proplake,
                icon: <CustomIcon><MdOutlineMenuBook style={{ width: "100%", height: "100%" }} /></CustomIcon>,
              },
              {
                title: "자료출처",
                path: paths.dashboard.guide.sources,
                icon: (
                  <CustomIcon>
                    <MdOutlineStorage style={{ width: "100%", height: "100%" }} />
                  </CustomIcon>
                ),
              },
            ],
          },
        ],
      },
      {
        subheader: "관리",
        admin: true,
        items: [
          {
            title: "관리",
            icon: (
              <CustomIcon>
                <MdOutlineAdminPanelSettings
                  sx={{ width: "100%", height: "100%" }}
                />
              </CustomIcon>
            ),
            items: [
              {
                title: "시스템 대시보드",
                path: paths.dashboard.admin.systemDashboard,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "유저관리",
                path: paths.dashboard.admin.userlist,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "아파트매치",
                path: paths.dashboard.admin.aptMatch,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "지역매칭",
                path: paths.dashboard.admin.regionMatch,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "미스매치 관리",
                path: paths.dashboard.admin.mismatchManage,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "수집기",
                path: paths.dashboard.admin.collectors,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "수집 정보",
                path: paths.dashboard.admin.collectionInfo,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "에러 목록",
                path: paths.dashboard.admin.fails,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "서버로그",
                path: paths.dashboard.admin.serverLogs,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "블로그 관리",
                path: paths.dashboard.admin.blog,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "쿠폰 관리",
                path: paths.dashboard.admin.coupons,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "공지 관리",
                path: paths.dashboard.admin.notices,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "게시판 관리",
                path: paths.dashboard.admin.community,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "평매물시세조정",
                path: paths.dashboard.admin.priceOutliers,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "DataLake수집",
                path: paths.dashboard.admin.datalakeCollector,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "주식정보",
                path: paths.dashboard.admin.stocks,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
            ],
          },
        ],
      },
      {
        subheader: "테스트",
        admin: true,
        items: [
          {
            title: "테스트 항목",
            path: paths.dashboard.test.index,
            icon: (
              <CustomIcon>
                <GrTest sx={{ width: "100%", height: "100%" }} />
              </CustomIcon>
            ),
            items: [
              {
                title: "구지역분석",
                path: paths.dashboard.regions.info,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "시장현황(주간증감) 고도화",
                path: paths.dashboard.test.marketWeeklyAdvanced,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "Mixed",
                path: paths.dashboard.test.graph.mixed,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "Scatter Plot",
                path: paths.dashboard.test.graph.scatter,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "Nivo Line",
                path: paths.dashboard.test.graph.nivoLine,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "Highchart TileMap",
                path: paths.dashboard.test.graph.highchartTileMap,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "Highchart HeatMap",
                path: paths.dashboard.test.graph.highchartHeatMap,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "Highchart Syncronized",
                path: paths.dashboard.test.graph.highchartSyncronized,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "Highchart Overlay Columns",
                path: paths.dashboard.test.graph.highchartOverlayColumns,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "지역 선택",
                path: paths.dashboard.test.component.regionFilter,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "데이터 레이크",
                path: paths.dashboard.test.component.datalake,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "Full Layout",
                path: paths.dashboard.test.layout.fullLayout,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "Geo Map",
                path: paths.dashboard.test.map.geoMap,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "Naver Map",
                path: paths.dashboard.test.map.naverMap,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },

              {
                title: "Region Map",
                path: paths.dashboard.test.map.regionMap,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "Gungu Group Filter",
                path: paths.dashboard.test.component.gunguGroupFilter,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "CustomTable",
                path: paths.dashboard.test.component.customTable,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
              {
                title: "DataTable",
                path: paths.dashboard.test.component.datatable,
                icon: (
                  <SvgIcon fontSize="small">
                    <File01Icon />
                  </SvgIcon>
                ),
              },
            ],
          },
        ],
      },
      // {
      //   items: [
      //     {
      //       title: t(tokens.nav.overview),
      //       path: paths.dashboard.index,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <HomeSmileIcon />
      //         </SvgIcon>
      //       ),
      //     },
      //     {
      //       title: t(tokens.nav.analytics),
      //       path: paths.dashboard.analytics,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <BarChartSquare02Icon />
      //         </SvgIcon>
      //       ),
      //     },
      //     {
      //       title: t(tokens.nav.ecommerce),
      //       path: paths.dashboard.ecommerce,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <LineChartUp04Icon />
      //         </SvgIcon>
      //       ),
      //     },
      //     {
      //       title: t(tokens.nav.crypto),
      //       path: paths.dashboard.crypto,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <CurrencyBitcoinCircleIcon />
      //         </SvgIcon>
      //       ),
      //       label: (
      //         <Chip
      //           color="primary"
      //           label="New"
      //           size="small"
      //         />
      //       ),
      //     },
      //     {
      //       title: t(tokens.nav.account),
      //       path: paths.dashboard.account,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <HomeSmileIcon />
      //         </SvgIcon>
      //       ),
      //     },
      //   ],
      // },
      // {
      //   subheader: t(tokens.nav.concepts),
      //   items: [
      //     {
      //       title: t(tokens.nav.customers),
      //       path: paths.dashboard.customers.index,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <Users03Icon />
      //         </SvgIcon>
      //       ),
      //       items: [
      //         {
      //           title: t(tokens.nav.list),
      //           path: paths.dashboard.customers.index,
      //         },
      //         {
      //           title: t(tokens.nav.details),
      //           path: paths.dashboard.customers.details,
      //         },
      //         {
      //           title: t(tokens.nav.edit),
      //           path: paths.dashboard.customers.edit,
      //         },
      //       ],
      //     },
      //     {
      //       title: t(tokens.nav.productList),
      //       path: paths.dashboard.products.index,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <ShoppingBag03Icon />
      //         </SvgIcon>
      //       ),
      //       items: [
      //         {
      //           title: t(tokens.nav.list),
      //           path: paths.dashboard.products.index,
      //         },
      //         {
      //           title: t(tokens.nav.create),
      //           path: paths.dashboard.products.create,
      //         },
      //       ],
      //     },
      //     {
      //       title: t(tokens.nav.orderList),
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <ShoppingCart01Icon />
      //         </SvgIcon>
      //       ),
      //       path: paths.dashboard.orders.index,
      //       items: [
      //         {
      //           title: t(tokens.nav.list),
      //           path: paths.dashboard.orders.index,
      //         },
      //         {
      //           title: t(tokens.nav.details),
      //           path: paths.dashboard.orders.details,
      //         },
      //       ],
      //     },
      //     {
      //       title: t(tokens.nav.invoiceList),
      //       path: paths.dashboard.invoices.index,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <ReceiptCheckIcon />
      //         </SvgIcon>
      //       ),
      //       items: [
      //         {
      //           title: t(tokens.nav.list),
      //           path: paths.dashboard.invoices.index,
      //         },
      //         {
      //           title: t(tokens.nav.details),
      //           path: paths.dashboard.invoices.details,
      //         },
      //       ],
      //     },
      //     {
      //       title: t(tokens.nav.logistics),
      //       path: paths.dashboard.logistics.index,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <Truck01Icon />
      //         </SvgIcon>
      //       ),
      //       items: [
      //         {
      //           title: t(tokens.nav.dashboard),
      //           path: paths.dashboard.logistics.index,
      //         },
      //         {
      //           title: t(tokens.nav.fleet),
      //           path: paths.dashboard.logistics.fleet,
      //         },
      //       ],
      //     },
      //     {
      //       title: t(tokens.nav.academy),
      //       path: paths.dashboard.academy.index,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <GraduationHat01Icon />
      //         </SvgIcon>
      //       ),
      //       items: [
      //         {
      //           title: t(tokens.nav.dashboard),
      //           path: paths.dashboard.academy.index,
      //         },
      //         {
      //           title: t(tokens.nav.course),
      //           path: paths.dashboard.academy.courseDetails,
      //         },
      //       ],
      //     },
      //     {
      //       title: t(tokens.nav.jobList),
      //       path: paths.dashboard.jobs.index,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <Building04Icon />
      //         </SvgIcon>
      //       ),
      //       items: [
      //         {
      //           title: t(tokens.nav.browse),
      //           path: paths.dashboard.jobs.index,
      //         },
      //         {
      //           title: t(tokens.nav.details),
      //           path: paths.dashboard.jobs.companies.details,
      //         },
      //         {
      //           title: t(tokens.nav.create),
      //           path: paths.dashboard.jobs.create,
      //         },
      //       ],
      //     },
      //     {
      //       title: t(tokens.nav.socialMedia),
      //       path: paths.dashboard.social.index,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <Share07Icon />
      //         </SvgIcon>
      //       ),
      //       items: [
      //         {
      //           title: t(tokens.nav.profile),
      //           path: paths.dashboard.social.profile,
      //         },
      //         {
      //           title: t(tokens.nav.feed),
      //           path: paths.dashboard.social.feed,
      //         },
      //       ],
      //     },
      //     {
      //       title: t(tokens.nav.blog),
      //       path: paths.dashboard.blog.index,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <LayoutAlt02Icon />
      //         </SvgIcon>
      //       ),
      //       items: [
      //         {
      //           title: t(tokens.nav.postList),
      //           path: paths.dashboard.blog.index,
      //         },
      //         {
      //           title: t(tokens.nav.postDetails),
      //           path: paths.dashboard.blog.postDetails,
      //         },
      //         {
      //           title: t(tokens.nav.postCreate),
      //           path: paths.dashboard.blog.postCreate,
      //         },
      //       ],
      //     },
      //     {
      //       title: t(tokens.nav.fileManager),
      //       path: paths.dashboard.fileManager,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <Upload04Icon />
      //         </SvgIcon>
      //       ),
      //     },
      //     {
      //       title: t(tokens.nav.kanban),
      //       path: paths.dashboard.kanban,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <CheckDone01Icon />
      //         </SvgIcon>
      //       ),
      //     },
      //     {
      //       title: t(tokens.nav.mail),
      //       path: paths.dashboard.mail,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <Mail03Icon />
      //         </SvgIcon>
      //       ),
      //     },
      //     {
      //       title: t(tokens.nav.chat),
      //       path: paths.dashboard.chat,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <MessageChatSquareIcon />
      //         </SvgIcon>
      //       ),
      //     },
      //     {
      //       title: t(tokens.nav.calendar),
      //       path: paths.dashboard.calendar,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <CalendarIcon />
      //         </SvgIcon>
      //       ),
      //     },
      //   ],
      // },
      // {
      //   subheader: t(tokens.nav.pages),
      //   items: [
      //     {
      //       title: t(tokens.nav.auth),
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <Lock01Icon />
      //         </SvgIcon>
      //       ),
      //       items: [
      //         {
      //           title: t(tokens.nav.login),
      //           items: [
      //             {
      //               title: "Classic",
      //               path: paths.authDemo.login.classic,
      //             },
      //             {
      //               title: "Modern",
      //               path: paths.authDemo.login.modern,
      //             },
      //           ],
      //         },
      //         {
      //           title: t(tokens.nav.register),
      //           items: [
      //             {
      //               title: "Classic",
      //               path: paths.authDemo.register.classic,
      //             },
      //             {
      //               title: "Modern",
      //               path: paths.authDemo.register.modern,
      //             },
      //           ],
      //         },
      //         {
      //           title: t(tokens.nav.forgotPassword),
      //           items: [
      //             {
      //               title: "Classic",
      //               path: paths.authDemo.forgotPassword.classic,
      //             },
      //             {
      //               title: "Modern",
      //               path: paths.authDemo.forgotPassword.modern,
      //             },
      //           ],
      //         },
      //         {
      //           title: t(tokens.nav.resetPassword),
      //           items: [
      //             {
      //               title: "Classic",
      //               path: paths.authDemo.resetPassword.classic,
      //             },
      //             {
      //               title: "Modern",
      //               path: paths.authDemo.resetPassword.modern,
      //             },
      //           ],
      //         },
      //         {
      //           title: t(tokens.nav.verifyCode),
      //           items: [
      //             {
      //               title: "Classic",
      //               path: paths.authDemo.verifyCode.classic,
      //             },
      //             {
      //               title: "Modern",
      //               path: paths.authDemo.verifyCode.modern,
      //             },
      //           ],
      //         },
      //       ],
      //     },
      //     {
      //       title: t(tokens.nav.pricing),
      //       path: paths.pricing,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <CreditCard01Icon />
      //         </SvgIcon>
      //       ),
      //     },
      //     {
      //       title: t(tokens.nav.checkout),
      //       path: paths.checkout,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <LogOut01Icon />
      //         </SvgIcon>
      //       ),
      //     },
      //     {
      //       title: t(tokens.nav.contact),
      //       path: paths.contact,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <Mail04Icon />
      //         </SvgIcon>
      //       ),
      //     },
      //     {
      //       title: t(tokens.nav.error),
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <XSquareIcon />
      //         </SvgIcon>
      //       ),
      //       items: [
      //         {
      //           title: "401",
      //           path: paths["401"],
      //         },
      //         {
      //           title: "404",
      //           path: paths["404"],
      //         },
      //         {
      //           title: "500",
      //           path: paths["500"],
      //         },
      //       ],
      //     },
      //   ],
      // },
      // {
      //   subheader: "Misc",
      //   items: [
      //     {
      //       title: "Level 0",
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <AlignLeft02Icon />
      //         </SvgIcon>
      //       ),
      //       items: [
      //         {
      //           title: "Level 1a",
      //           items: [
      //             {
      //               title: "Level 2a",
      //               items: [
      //                 {
      //                   title: "Level 3a",
      //                 },
      //                 {
      //                   title: "Level 3b",
      //                   disabled: true,
      //                 },
      //               ],
      //             },
      //             {
      //               title: "Level 2b",
      //             },
      //           ],
      //         },
      //         {
      //           title: "Level 1b",
      //         },
      //       ],
      //     },
      //     {
      //       title: "Disabled",
      //       disabled: true,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <XSquareIcon />
      //         </SvgIcon>
      //       ),
      //     },
      //     {
      //       title: "Label",
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <File01Icon />
      //         </SvgIcon>
      //       ),
      //       label: (
      //         <Chip
      //           color="primary"
      //           label="New"
      //           size="small"
      //         />
      //       ),
      //     },
      //     {
      //       title: "Blank",
      //       path: paths.dashboard.blank,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <File01Icon />
      //         </SvgIcon>
      //       ),
      //     },
      //     {
      //       title: "External Link",
      //       path: "https://devias.io",
      //       external: true,
      //       icon: (
      //         <SvgIcon fontSize="small">
      //           <File01Icon />
      //         </SvgIcon>
      //       ),
      //     },
      //   ],
      // },
    ];
  }, [isAdmin]);
};
